import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOrderedItemsReport = get(
  'reservation.components.reports.orderedItems'
);

export const getOrderedItemsReportSearchQuery = createSelector(
  getOrderedItemsReport,
  get('searchQuery')
);
